import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getProjectBySlug } from "../../API/Projects/projectsService";
import { CalendarClock } from "lucide-react";
import background from "../../images/aquavesc.jpg";

const ProjectSinglePage = () => {
  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

  const { slug } = useParams();
  const [projectData, setProjectData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (slug) {
        try {
          const data = await getProjectBySlug(slug);

          if (data) {
            setProjectData(data);
          } else {
            setError('Projet non trouvé');
          }
        } catch (err) {
          console.error('Error fetching project:', err);
          setError('Erreur lors du chargement du projet');
        } finally {
          setLoading(false);
        }
      } else {
        setError('Aucun identifiant de projet fourni');
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div>Chargement...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-red-600">{error}</div>
      </div>
    );
  }

  if (!projectData) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div>Projet non trouvé</div>
      </div>
    );
  }

  return (
    <div className="mt-10 ">
      <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
        <div className="inline-block rounded-sm bg-primary">
          <p className="p-2 font-bold text-white">
            # Travaux en cours
          </p>
        </div>
        <div className="mt-5">
          <h1 className="text-2xl font-bold text-black">
            {projectData.title}
          </h1>

          <div className="flex mt-2 space-x-3">
            <div>
              <CalendarClock className="text-primary" />
            </div>
            <div className="text-black ">
              {projectData.date_debut ? (
                new Date(projectData.date_debut).toLocaleDateString("fr-FR", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                })
              ) : (
                "Date non spécifiée"
              )}
            </div>
          </div>
          <hr className="w-full h-1 mt-5 bg-primary" />
        </div>

        <div className="mt-5">
          <img
            src={
              projectData?.image
                ? `${uploadUrl}/projects/${projectData?.image}`
                : background
            }
            alt=""
          />
        </div>

        <div className="mt-10">
          {projectData.description ? (
            <div dangerouslySetInnerHTML={{ __html: projectData.description }} />
          ) : (
            <p>Description non disponible</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectSinglePage;
